export const LogoutEvent = 'logout'
export const DismissModalEvent = 'dismissModal'
